import { render, staticRenderFns } from "./DocumentSign.vue?vue&type=template&id=3bc44ea4&scoped=true"
import script from "./DocumentSign.vue?vue&type=script&lang=js"
export * from "./DocumentSign.vue?vue&type=script&lang=js"
import style0 from "./DocumentSign.vue?vue&type=style&index=0&id=3bc44ea4&prod&lang=scss&scoped=true"
import style1 from "./DocumentSign.vue?vue&type=style&index=1&id=3bc44ea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc44ea4",
  null
  
)

export default component.exports